import React, {Component} from 'react';
import {FormicaProps, withFormica} from "../../helpers/withFormica";
import {RootState} from "../../redux/store";
import {changeCurrentCategory, changeCurrentComponent, changeSidebarCollapse, toggleHamburgerMenu} from "../../redux/actions/PageActions";
import {connect} from "react-redux";
import {ConnectedProps} from "react-redux/es/exports";
import Icon from "../../icons/Icon";
import ComponentName from "../../constant/ComponentName";
import EnvironmentUtil from "../../util/EnvironmentUtil";
import {InstanceContainer} from "../../config/binding/InstanceBinding";
import Injectables from "../../constant/Injectables";
import RoleHelper from "../../RoleHelper";
import {SidebarMenuItemProps} from "./SidebarMenuItem";
import SidebarMenuItemContainer from "./SidebarMenuItemContainer";
import LanguageUtil from "../../util/LanguageUtil";

class CraMenu extends Component<Props> {

  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  private cra: SidebarMenuItemProps[] = [
    {
      name: LanguageUtil.get({id:"common.label.policy",defaultMessage:"Policy"}),
      field: "Cra",
      path: "policy",
      icon: <Icon icon={"sidebar-policy"} className={"text-f-black-2 group-hover:text-primary"} size={16}/>,
      children: [],
      component: ComponentName.POLICY,
      visible: this.environmentUtil.getCra(),
    },
    {
      name: LanguageUtil.get({id:"common.label.assessment",defaultMessage:"Assessment"}),
      field: "Cra",
      path: "assessment",
      icon: <Icon icon={"sidebar-assessment"} className={"text-f-black-2 group-hover:text-primary"} size={16}/>,
      children: [],
      component: ComponentName.ASSESSMENT,
      visible: this.environmentUtil.getCra(),
    }
  ]

  public render() {
    const {collapsed, goPage, router} = this.props;
    const pathName = router.location.pathname.split("/")[1];
    const filteredCra = this.cra.filter(m => (m.visible != undefined ? m.visible : true) && RoleHelper.canView(m.field));
    if (filteredCra?.length == 0) {
      return;
    }
    return (
      <SidebarMenuItemContainer items={filteredCra}
                                goPage={goPage}
                                pathName={pathName}
                                collapsed={collapsed}
                                title={"CRA"}
                                collapsedTitle={"CRA"}/>
    );
  }
}

interface Props extends ReduxProps, FormicaProps {
  goPage(item: SidebarMenuItemProps): void;
}

const mapStateToProps = (state: RootState) => ({
  collapsed: state.page.sidebarCollapsed,
  page: state.page,
  component: state.component
});
const mapDispatchToProps = {
  changeCurrentComponent,
  toggleHamburgerMenu,
  changeCurrentCategory,
  changeSidebarCollapse,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(CraMenu));